<template>
  <modal
    width="45"
    v-loading="loading"
    :show-modal="showModal"
    @close-modal="$emit('close-modal')"
  >
    <div>
      <h3 class="font-semibold text-lg mb-3">Manage Booking</h3>
      <p>Select a manage booking option to continue</p>

      <div class="py-4">
        <div v-if="!shouldShowMap" class="flex items-center mb-2">
          <label for="EditBooking" class="radio-label">
            <input
              class=" bg-primary-yellow text-secondary-yellow"
              name="shippingMethod"
              type="radio"
              id="EditBooking"
              value="EditBooking"
              v-model="action"
            />
            Edit Booking
            <span> </span>
          </label>
        </div>

        <div v-if="!shouldShowMap" class=" flex items-center mb-2">
          <label for="PickupSchedule" class="radio-label">
            <input
              class=" bg-primary-yellow text-secondary-yellow"
              name="shippingMethod"
              type="radio"
              id="PickupSchedule"
              value="Pick-up Schedule"
              v-model="action"
            />
            Pick-up Schedule
            <span> </span>
          </label>
        </div>

        <div v-if="!shouldShowMap" class="flex items-center mb-2">
          <label for="DeliverySchedule" class="radio-label">
            <input
              class=" bg-primary-yellow text-secondary-yellow"
              name="shippingMethod"
              type="radio"
              id="DeliverySchedule"
              value="Delivery Schedule"
              v-model="action"
            />
            Delivery Schedule
            <span> </span>
          </label>
        </div>

        <div v-if="!shouldShowMap" class="flex items-center mb-2">
          <label for="RequestReturn" class="radio-label">
            <input
              class=" bg-primary-yellow text-secondary-yellow"
              name="shippingMethod"
              type="radio"
              id="RequestReturn"
              value="Request Return"
              v-model="action"
            />
            Request Return
            <span> </span>
          </label>
        </div>

        <div class="flex items-center mb-2">
          <label for="CancelBooking" class="radio-label">
            <input
              class=" bg-primary-yellow text-secondary-yellow"
              name="shippingMethod"
              type="radio"
              id="CancelBooking"
              value="Cancel Booking"
              v-model="action"
            />
            Cancel Booking
            <span> </span>
          </label>
        </div>
      </div>
      <p class="mt-8" v-if="chaneBookingTime">
        <abbr class="text-primary-yellow">*</abbr> Changes to this booking might
        affect your booking cost. Click Next to continue.
      </p>

      <div class="mt-5 flex justify-between">
        <button @click="$emit('close-modal')">Cancel</button>
        <button class="py-2 px-8 bg-primary-yellow" @click="onNext">
          Next
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      action: "EditBooking",
    };
  },
  computed: {
    shipping() {
      return this.$store.getters.newCurrentShipping;
    },
    shouldShowMap() {
      return (
        this.shipping?.shippingMethod === "door-to-door" ||
        (this.shipping?.shippingMethod === "terminal-to-door" &&
          !this.shipping?.shippingservice)
      );
    },
    chaneBookingTime(){
      return this.action == 'Delivery Schedule' 
    }
  },
  methods: {
    autoLoadBooking(val) {
      let splitval = {
        consignee: val?.consigneelocation,
        prevShipper: val?.shipperlocation,
        shipper: val?.shipperlocation,
        packages: val?.packagees,
        initialShipping: val
      };
      this.$store.dispatch("saveLatestInitialBookingData", splitval);
      this.$router.push({ name: "BookingFlow" });
      this.$store.dispatch('saveLatestNewBookinTabNum', 1)
    },
    onNext() {
      switch (this.action) {
        case "Request Return":
          this.$emit("requestReturn");
          break;
        case "Pick-up Schedule":
          this.$emit("managePickUpModal");
          break;
        case "Delivery Schedule":
          this.$emit("manageDeliveryModal");
          break;
        case "Cancel Booking":
          this.$emit("cancleBookingModal");
          break;
        case "EditBooking":
            this.autoLoadBooking(this.shipping)
            break;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
